<template>
  <f7-page @page:init="onPageInit" id="body"
    :style="{ backgroundImage: 'url(' + require('@/assets/bg/' + randomBg + '.png') + ')' }">

    <div class="container"></div>

    <div class="backdrop">
      <!-- TODO
       
      -->
      <br>
      <f7-block-title @click="shareUrl" class="heading1">Archipelago Web<img width="24px"
          src="@/assets/share.png"></f7-block-title>
      <div v-if="!headless">
        <f7-block-title id="connectHeader" class="heading2">Connect with AP</f7-block-title>
        <div class="grid small-grid-cols-2 medium-grid-cols-3 large-grid-cols-6 grid-gap">
          <div>
            <label for="game-input" class="mcLabel">Game</label>
            <f7-input id="game-input" v-model:value="game" class="mcInput" type="text" placeholder="Game"></f7-input>
          </div>
          <div>
            <label for="host-input" class="mcLabel">Host</label>
            <f7-input id="host-input" v-model:value="host" class="mcInput" type="text" placeholder="Host"></f7-input>

            <f7-button class="overlayButton" popover-open=".popover-menu2"><img width="24px"
                src="@/assets/web.png"></f7-button>

            <f7-popover style="width: 800px;" class="popover-menu2">
              <f7-list>
                <f7-list-input v-model:value="connectionTextToParse" label="Paste Archipelago Site Content:"
                  type="textarea" placeholder="STR+A & STRG+V > STRG+C in here">
                </f7-list-input>
                <f7-list-item style="width: 100%;height: 64px;" @click="parseConnectionFromText" class="mcButton gray"
                  popover-close link="#">Parse</f7-list-item>
              </f7-list>
            </f7-popover>

          </div>
          <div>
            <label for="port-input" class="mcLabel">Port</label>
            <f7-input id="port-input" v-model:value="port" class="mcInput" type="text" placeholder="Port"></f7-input>
          </div>
          <div>
            <label for="name-input" class="mcLabel">Name</label>
            <f7-input id="name-input" v-model:value="name" class="mcInput" type="text" placeholder="Name"></f7-input>
            <f7-button v-if="allPlayers.length > 0" class="overlayButton" popover-open=".popover-menu"><img width="24px"
                src="@/assets/reload.png"></f7-button>
            <f7-popover class="popover-menu custom-scroll-popover">
              <f7-list>
                <f7-list-item v-for="(item, index) in allPlayers" :key="index"
                  @click="switchGame(allPlayersSorted[index])" link="#" popover-close
                  v-model:title="allPlayersSorted[index].name" />
              </f7-list>
            </f7-popover>
          </div>
          <div>
            <label for="password-input" class="mcLabel">Password</label>
            <f7-input id="password-input" v-model:value="password" class="mcInput" type="text"
              placeholder="Password"></f7-input>
          </div>
          <div>
            <label class="mcLabel">Status</label>
            <f7-button class=""
              :class="[connectButtonText === 'Connected' ? 'mcButton green' : 'mcButton gray', 'errorClass']"
              @click="connect">{{ connectButtonText }}</f7-button>
          </div>
        </div>

        <f7-block-title class="heading2">Settings</f7-block-title>

        <div class="grid small-grid-cols-2 medium-grid-cols-3 large-grid-cols-6 grid-gap">
          <div>
            <label for="winPercent-input" class="mcLabel">Rate to win %</label>
            <f7-input id="winPercent-input" v-model:value="winPercent" class="mcInput" type="number" min="1" max="100"
              placeholder="Rate to win %"></f7-input>
          </div>
          <div>
            <label for="columnCount-input" class="mcLabel">Column Count</label>
            <f7-input id="columnCount-input" v-model:value="columnCount" class="mcInput" type="number" min="1" max="10"
              placeholder="Column Count"></f7-input>
          </div>
          <div>
            <label for="sortSelect-input" class="mcLabel">Sort by</label>
            <f7-input type="select" class="mcSelect" v-model:value="sortSelect" @change="saveSettings">
              <option value="Id">ID</option>
              <option value="Name">Name</option>
            </f7-input>
          </div>
          <div>
            <span>Enable Notes</span><br>
            <input id="enableNotes-input" v-model="enableNotes" class="css-checkbox" type="checkbox">
            <label for="enableNotes-input"></label>
          </div>
          <div>
            <span>Hide Checked</span><br>
            <input name="hideChecked" v-model="hideChecked" id="hideChecked" type="checkbox" class="css-checkbox">
            <label for="hideChecked"></label>
          </div>
          <div>
            <span>Only Hinted</span><br>
            <input name="onlyHinted" v-model="onlyHinted" id="onlyHinted" type="checkbox" class="css-checkbox">
            <label for="onlyHinted"></label>
          </div>
        </div>
      </div>

      <f7-block-title class="heading2">Reach the Goal</f7-block-title>

      <div id="myProgress">
        <f7-button v-if="progress >= winPercent" class="mcButton green" @click="releaseAll"> YOU WON! CLICK TO RELEASE
          ALL 🥰</f7-button>
        <div :style="{ width: progress + '%', color: progress < 15 ? 'black' : 'white' }" id="myBar"><span
            style="white-space: nowrap;">{{ progress }}% (+{{ progressPerCheck }}% per Check)</span></div>
      </div>

      <label for="search-input" class="mcLabel"></label>
      <f7-input v-model:value="search" placeholder="Search here..." class="mcInput" id="search-input"
        type="text"></f7-input>
      <f7-button v-if="search !== ''" @click="search = ''" style="margin-bottom: -40px;" class="overlayButton"><img
          width="24px" src="@/assets/cross.png"></f7-button>
    </div>

    <div>
      <f7-toolbar bottom tabbar>
        <f7-link tab-link="#tab-checks" tab-link-active>
          Checks
          <span class="tab-subtitle">({{ myCheckedLocations.length }} / {{ myLocations.size }})</span>
        </f7-link>
        <f7-link @click="forceUpdateComputed" tab-link="#tab-items">
          Unlocks & Items
          <span class="tab-subtitle">({{ recievedItems.length }})</span>
        </f7-link>
        <f7-link tab-link="#tab-log">
          Log
          <span class="tab-subtitle">({{ log.length }})</span>
        </f7-link>
        <f7-link @click="forceUpdateComputed" tab-link="#tab-hint">
          Hints
          <span class="tab-subtitle">({{ myHints.length }})</span>
        </f7-link>
      </f7-toolbar>
      <f7-tabs animated>
        <f7-tab id="tab-checks" class="page-content" tab-active>
          <table>
            <thead>
              <tr v-if="enableNotes">
                <th><f7-button @click="clearNotes">CLEAR NOTES</f7-button></th>
                <th v-for="(item, index) in columns" :key="index">
                  <input class="mcInput note inverted" v-model="columns[index]" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(chunk, chunkIndex) in chunkedLocations" :key="chunkIndex">
                <td class="note-background" v-if="enableNotes">
                  <input class="mcInput note" v-model="rows[chunkIndex]" />
                </td>
                <td v-for="(value, key) in chunk" :key="key">
                  <!-- FOR DEV -->
                  <div style="width: 200px;" v-if="dev" v-html="toHTMLRichText(value[1])"></div>

                  <f7-button style=""
                    :class="[this.myCheckedLocations.includes(value[0]) ? 'checked' : 'unchecked', 'errorClass']"
                    @click="check(value[0], $event)">
                    <span>{{ value[1] }}</span>
                    <span v-if="getHintedItem(value[0]) !== ''" style="font-size: 85%;">{{ getHintedItem(value[0])
                      }}</span>
                  </f7-button>

                  <!-- <span>Index: {{ key }}, ID: {{ value[0] }}, Name: {{ value[1] }}</span> -->
                </td>
              </tr>
            </tbody>
          </table>
        </f7-tab>

        <f7-tab id="tab-items" class="page-content">
          <table>
            <tbody>
              <tr v-for="(chunk, chunkIndex) in chunkedItems" :key="chunkIndex">
                <td v-for="(value, key) in chunk" :key="key">
                  <!-- FOR DEV -->
                  <div style="width: 200px;" v-if="dev" v-html="toHTMLRichText(value[1])"></div>
                  <!-- <div v-if="dev" v-html="hasItem(value[0])"></div> -->
                  <!-- <div v-if="dev" v-html="value[0]"></div> -->

                  <f7-button :class="[hasItem(value[0]) > 0 ? 'checked' : 'unchecked', 'errorClass']"
                    @click="prepareHint(value[1])">

                    <span>{{ hasItem(value[0]) + 'x ' + value[1] }}</span>
                    <span v-if="getHintedLocation(value[0]) !== ''" style="font-size: 85%;">{{
                      getHintedLocation(value[0]) }}</span>

                  </f7-button>
                </td>
              </tr>
            </tbody>
          </table>
        </f7-tab>
        <f7-tab id="tab-log" class="page-content">
          <f7-button class="mcButton black" @click="clearLog">Clear Local Log</f7-button>
          <f7-input v-model:value="chat" class="mcInput" placeholder="Chat here..." v-on:keyup.enter="sendChat"
            type="text"></f7-input>
          <div class="log">
            <div v-for="(item, index) in filteredLog" :key="index">
              <div v-html="toHTMLRichText(item)"></div>
              <br>
            </div>
          </div>
        </f7-tab>
        <f7-tab id="tab-hint" class="page-content">
          <div class="log">
            <div v-for="(item, index) in filteredHints" :key="index">
              <div v-html="toHTMLRichText(item)"></div><br>
              <br>
            </div>
          </div>
        </f7-tab>
      </f7-tabs>
    </div>
  </f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import { Client, ITEMS_HANDLING_FLAGS, SERVER_PACKET_TYPE } from '@/archipelago100.js';
import { Fireworks } from 'fireworks-js'

export default {
  data() {
    return {
      game: '',
      host: 'archipelago.gg',
      port: '',
      name: '',
      password: '',
      winPercent: 50,
      columnCount: 3,
      sortSelect: 'Id',
      enableNotes: false,
      hideChecked: false,
      onlyHinted: false,
      connectButtonClass: 'gray',
      connectButtonText: 'Click to Connect',
      tableHTML: '',
      search: '',
      columns: ["", ""],
      rows: ["", ""],
      log: [],
      chat: '',
      headless: false,
      forceUpdateKey: 0,
      randomBg: Math.floor(Math.random() * 68),
      fireworks: null,
      connectionTextToParse: '',
      allPlayers: [],
      recievedItems: []
    };
  },
  mounted() {
    const container = document.querySelector('.container')
    this.fireworks = new Fireworks(container, {
      autoresize: false,
      opacity: 1.0,
      acceleration: 1.05,
      friction: 0.97,
      gravity: 1.5,
      particles: 100,
      traceLength: 3,
      traceSpeed: 3,
      explosion: 10,
      intensity: 30,
      flickering: 50,
      lineStyle: 'round',
      hue: {
        min: 0,
        max: 360
      },
      delay: {
        min: 30,
        max: 60
      },
      rocketsPoint: {
        min: 0,
        max: 100
      },
      lineWidth: {
        explosion: {
          min: 3,
          max: 6
        },
        trace: {
          min: 3,
          max: 6
        }
      },
      brightness: {
        min: 90,
        max: 100
      },
      decay: {
        min: 0.015,
        max: 0.03
      },
      mouse: {
        click: false,
        move: false,
        max: 1
      },
      sound: {
        enabled: true,
        files: [
          require('@/assets/sounds/firework_2.ogg'),
          require('@/assets/sounds/firework_3.ogg'),
          require('@/assets/sounds/firework_4.ogg'),
          require('@/assets/sounds/firework_5.ogg'),
          require('@/assets/sounds/firework_6.ogg'),
          require('@/assets/sounds/firework_7.ogg')
        ],
        volume: {
          min: 10,
          max: 10
        }
      }
    })
  },
  computed: {
    myLocations() {
      this.forceUpdateKey;
      var myLocations = new Map();

      if (window.client.data.package.get(this.game) === undefined) {
        return myLocations;
      }
      var obj = window.client.data.package.get(this.game).location_name_to_id

      for (const [value, key] of Object.entries(obj)) {
        myLocations.set(key, value);
      }

      return myLocations;
    },
    myCheckedLocations() {
      this.forceUpdateKey;
      if (window.client.locations !== undefined) {
        return window.client.locations.checked;
      } else {
        return [];
      }
    },
    myItems() {
      this.forceUpdateKey;
      var myItems = new Map();

      if (window.client.data.package.get(this.game) === undefined) {
        return myItems;
      }
      var obj = window.client.data.package.get(this.game).item_name_to_id

      for (const [value, key] of Object.entries(obj)) {
        myItems.set(key, value);
      }

      return myItems;
    },
    myHints() {
      this.forceUpdateKey;
      return window.client.hints.mine;
    },
    filteredHints() {
      this.forceUpdateKey;
      var filtered = []
      for (let index = 0; index < this.myHints.length; index++) {
        const value = this.myHints[index];
        var skip = false

        if (this.hideChecked && value.found) {
          skip = true;
        }

        var text = this.hintToText(value)

        if (!text.toLowerCase().includes(this.search.toLowerCase())) {
          skip = true;
        }

        if (!skip) {
          filtered.push(text);
        }
      }

      return filtered;
    },
    filteredLocations() {
      this.forceUpdateKey;
      var filtered = new Map();

      for (const [key, value] of this.myLocations) {
        var skip = false;

        if (key < 1) {
          skip = true;
        }

        if (this.hideChecked && this.myCheckedLocations.includes(key)) {
          skip = true;
        }

        if (this.onlyHinted && this.getHintedItem(key) === "") {
          skip = true;
        }

        if (!value.toLowerCase().includes(this.search.toLowerCase())) {
          skip = true;
        }

        if (!skip) {
          filtered.set(key, value);
        }
      }

      if (this.sortSelect === 'Name') {
        filtered = new Map([...filtered.entries()].sort((a, b) => a[1].localeCompare(b[1])));
      }

      return filtered;
    },
    filteredItems() {
      this.forceUpdateKey;
      var filtered = new Map();

      for (const [key, value] of this.myItems) {
        var skip = false;

        if (key < 1) {
          skip = true;
        }

        if (this.hideChecked && this.myHints.includes(key)) {
          skip = true;
        }

        if (this.onlyHinted && this.getHintedLocation(key) === "") {
          skip = true;
        }

        if (!value.toLowerCase().includes(this.search.toLowerCase())) {
          skip = true;
        }

        if (!skip) {
          filtered.set(key, value);
        }

      }

      if (this.sortSelect === 'Name') {
        filtered = new Map([...filtered.entries()].sort((a, b) => a[1].localeCompare(b[1])));
      }

      return filtered;
    },
    filteredLog() {
      this.forceUpdateKey;
      var filtered = [];
      for (const data of this.log) {
        var msg = this.packetToText(data.data);

        if (msg.toLowerCase().includes(this.search.toLowerCase())) {
          filtered.push(msg);
        }
      }
      return filtered.reverse().slice(0, 50); //for performance
    },
    chunkedLocations() {
      this.forceUpdateKey;

      if (this.filteredLocations === undefined) {
        return;
      }

      const chunked = [];
      const entries = Array.from(this.filteredLocations.entries());
      for (let i = 0; i < entries.length; i += this.columns.length) {
        chunked.push(entries.slice(i, i + this.columns.length));
      }
      return chunked;
    },
    chunkedItems() {
      this.forceUpdateKey;

      if (this.filteredItems === undefined) {
        return;
      }

      const chunked = [];
      const entries = Array.from(this.filteredItems.entries());
      for (let i = 0; i < entries.length; i += this.columns.length) {
        chunked.push(entries.slice(i, i + this.columns.length));
      }
      return chunked;
    },
    progress() {
      this.forceUpdateKey;

      var percent = this.myCheckedLocations.length / this.myLocations.size * 100;
      if (isNaN(percent) || percent === Infinity) {
        return 0;
      }
      return percent.toFixed(2);

    },
    progressPerCheck() {
      this.forceUpdateKey;

      if (window.client.locations.checked === undefined) {
        return 0;
      }
      var percent = 1 / this.myLocations.size * 100;
      if (isNaN(percent) || percent === Infinity) {
        return 0;
      }
      return percent.toFixed(2);
    },
    allPlayersSorted() {
      this.forceUpdateKey;
      var objs = this.allPlayers;
      objs.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))

      return objs;
    }
  },
  methods: {
    forceUpdateComputed() {
      this.forceUpdateKey++;
    },
    saveSettings() {

      if (this.host.includes(":")) {
        this.port = this.host.split(':')[1]
        this.host = this.host.split(':')[0];
      }

      //Connection
      localStorage.setItem('game', this.game);
      localStorage.setItem('host', this.host);
      localStorage.setItem('port', this.port);
      localStorage.setItem('name', this.name);
      localStorage.setItem('password', this.password);
      localStorage.setItem('allPlayers', JSON.stringify(this.allPlayers))

      //Settings
      localStorage.setItem('winPercent', this.winPercent);
      localStorage.setItem('columnCount', this.columnCount);
      localStorage.setItem('sortSelect', this.sortSelect);
      localStorage.setItem('enableNotes', this.enableNotes);
      localStorage.setItem('hideChecked', this.hideChecked);
      localStorage.setItem('onlyHinted', this.onlyHinted);

      //notes
      if (this.enableNotes) {
        localStorage.setItem('columns', JSON.stringify(this.columns))
        localStorage.setItem('rows', JSON.stringify(this.rows))
      }

      //this.createTable();
      this.forceUpdateComputed();
      console.log('Settings saved');

    },
    shareUrl() {
      var url = window.location + '?game=' + this.game + '&host=' + this.host + '&port=' + this.port + '&name=' + this.name + '&password=' + this.password + '&winPercent=' + this.winPercent + '&columnCount=' + this.columnCount + '&sortSelect=' + this.sortSelect + '&enableNotes=' + this.enableNotes + '&hideChecked=' + this.hideChecked + '&onlyHinted=' + this.onlyHinted; //+ '&headless=false'

      //only on https navigator.clipboard.writeText(url);
      this.handleCopy(url);
    },
    onPageInit() {
    },
    loadSettings() {
      let urlParams = new URLSearchParams(window.location.search);

      //Connection
      this.game = urlParams.get('game') || urlParams.get('Game') || localStorage.getItem('game') || '';
      this.host = urlParams.get('host') || urlParams.get('Host') || localStorage.getItem('host') || 'archipelago.gg';
      this.port = urlParams.get('port') || urlParams.get('Port') || localStorage.getItem('port') || '';
      this.name = urlParams.get('name') || urlParams.get('Name') || localStorage.getItem('name') || '';
      this.password = urlParams.get('password') || urlParams.get('Password') || localStorage.getItem('password') || '';
      this.allPlayers = JSON.parse(localStorage.getItem('allPlayers')) || [];

      //settings
      this.winPercent = urlParams.get('winPercent') || localStorage.getItem('winPercent') || 80;
      this.columnCount = urlParams.get('columnCount') || localStorage.getItem('columnCount') || 3;
      this.sortSelect = localStorage.getItem('sortSelect') || 'Id';
      this.enableNotes = localStorage.getItem('enableNotes') === 'true';
      this.hideChecked = localStorage.getItem('hideChecked') === 'true';
      this.onlyHinted = localStorage.getItem('onlyHinted') === 'true';
      this.headless = urlParams.get('headless') || false;

      //notes
      if (this.enableNotes) {
        const columns = localStorage.getItem('columns');
        this.columns = columns ? JSON.parse(columns) : ["", ""];
        const rows = localStorage.getItem('rows');
        this.rows = rows ? JSON.parse(rows) : ["", ""];
      }

      //dev
      this.dev = urlParams.get('Dev')
      //this.dev = true;

      console.log('Settings loaded');
    },
    hintToText(value) {
      var found = " (not found)"
      if (value.found) {
        found = " (found)"
      }
      var text = this.typeToText({ text: value.receiving_player, player: value.receiving_player, type: "player_id" })
        + "'s " + this.typeToText({ text: value.item, player: value.receiving_player, type: "item_id" })
        + " at: " + this.typeToText({ text: value.finding_player, player: value.finding_player, type: "player_id" })
        + "'s " + this.typeToText({ text: value.location, player: value.finding_player, type: "location_id" })
        + found
      return text;
    },
    switchGame(data) {
      this.game = data.game;
      this.name = data.name;

      this.connect();

    },
    parseConnectionFromText() {
      if (this.connectionTextToParse === "") {
        return;
      }
      localStorage.clear();

      this.allPlayers = [];

      //IP & Port
      var text = this.connectionTextToParse;
      this.host = "archipelago.gg" //only hosting there, at the Moment
      this.port = text.split("archipelago.gg:")[1].split("'")[0];

      var gamesTable = text.split("Id	Name	Game	Download Link	Tracker Page")[1].split("Server Command.")[0].split(/\r?\n/);

      gamesTable.forEach(row => {
        var cols = row.split("\t");
        if (cols.length >= 3) {
          this.allPlayers.push({ name: cols[1], game: cols[2] })
        }
      });

      this.switchGame(this.allPlayers[0]);

      this.connectionTextToParse = "";
    },
    hasItem(id) {
      var found = 0;
      this.recievedItems.forEach(entry => {
        if (entry.item === id) {
          found++;
        }
      })
      return found;
    },
    getHintedItem(id) {
      var itemName = "";
      this.myHints.forEach(entry => {
        if (entry.location === id && entry.finding_player === this.getPlayerId(window.client.data.players, this.name)) {
          var item = {
            type: "item_id",
            text: entry.item
          }

          var player = {
            type: "player_id",
            text: entry.receiving_player
          }

          itemName = '(' + this.typeToText(item, entry.receiving_player) + ' to ' + this.typeToText(player) + ')';
        }
      })
      return itemName;
    },
    getHintedLocation(id) {
      var locName = "";
      this.myHints.forEach(entry => {
        if (entry.item === id && entry.receiving_player === this.getPlayerId(window.client.data.players, this.name)) {
          var loc = {
            type: "location_id",
            text: entry.location
          }

          var player = {
            type: "player_id",
            text: entry.finding_player
          }

          locName = '(' + this.typeToText(loc, entry.finding_player) + ' from ' + this.typeToText(player) + ')'; //TODO Multi Locations?
        }
      })
      return locName;
    },
    columnCountChanged() {
      if (this.columns.length > this.columnCount) {
        this.columns.length = this.columnCount; // Truncate the array
      } else {
        while (this.columns.length < this.columnCount) {
          this.columns.push(''); // Add empty strings until the array reaches the desired size
        }
      }
      this.saveSettings();
    },
    check(id, btn) {
      var audio = new Audio(require('@/assets/sounds/firework_start.ogg')); /* require('@/assets/sounds/firework_7.ogg') */
      audio.play();
      this.fireworks.launch(5)

      if (btn.target.classList.contains("unchecked")) {
        btn.target.classList.replace("unchecked", "checked"); //Update Button, so i dont need to wait for sync.
      } else { //he clicked the label, get the button.
        btn.target.parentElement.classList.replace("unchecked", "checked"); //Update Button, so i dont need to wait for sync.
      }



      window.client.locations.check(id);
      this.forceUpdateComputed();
      if (!this.myCheckedLocations.includes(id)) {
        this.changebackground();
      }
    },
    sendChat() {
      window.client.say(this.chat);
      this.chat = '';
    },
    prepareHint(name) {

      this.chat = '!hint ' + name;
      this.sendChat();
      //this.search = name;
      //this.switchToTab('#tab-hint')

      /*
      self.popup = f7.popup.create({
          content: `
              <div class="popup">
                <div class="page">
                  <div class="navbar">
                    <div class="navbar-bg"></div>
                    <div class="navbar-inner">
                      <div class="title">!Hint an Item</div>
                      <div class="right"><a  class="link popup-close">Close</a></div>
                    </div>
                  </div>
                  <div class="page-content">
                    <div class="block">
                      <p>You want to Hint for: `+name+` ? </p>
                      <button @click="sendChat()">!Hint `+name+` </button>
                    </div>
                  </div>
                </div>
              </div>
            `.trim(),
        }).open();
        */

      //this.switchToTab('#tab-log');
    },
    switchToTab(tabEl) {
      f7.tab.show(tabEl);
    },
    releaseAll() {
      var self = this;
      this.fireworks.start();
      window.setTimeout(function () { self.fireworks.stop() }, 5000);
      window.client.locations.autoRelease()
      localStorage.clear();
    },
    clearNotes() {
      this.columns = ["", ""];
      this.rows = ["", ""];
      this.columnCountChanged();
      this.saveSettings();
    },
    clearLog() {
      this.log = [];
      this.saveSettings();
    },
    changebackground() {
      var inum = 75;
      var rand1 = Math.round(Math.random() * (inum - 1));
      this.randomBg = rand1;
    },
    getPlayerId(map, searchValue) {
      for (let [key, value] of map.entries()) {
        if (value.name === searchValue)
          return key;
      }
    },
    typeToText(element, playerId = this.getPlayerId(window.client.data.players, this.name)) {
      var id = -1;
      id = Number(element.text);

      if (element.player !== undefined) {
        playerId = Number(element.player);
      }
      if (element.type === "player_id" && !isNaN(id)) {
        return window.client.players.name(Number(id));
      } else if (element.type === "item_id" && !isNaN(id)) {
        return window.client.items.name(window.client.players.game(Number(playerId)), Number(id))
      } else if (element.type === "location_id" && !isNaN(id)) {
        return window.client.locations.name(window.client.players.game(Number(playerId)), Number(id))
      }
      else if (element.text !== undefined) {
        return element.text;
      } else {
        return element;
      }
    },
    packetToText(packet) {
      if (packet === undefined) {
        return "";
      }
      var msg = "";
      packet.forEach(element => {
        msg += this.typeToText(element) + " ";
      });
      return msg;
    },
    handleCopy(content) {
      const textarea = document.createElement("textarea");
      textarea.textContent = content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
    replaceWithImage(text, replace, image) {
      var html = '<div style="display: inline-block;text-align: center;" ><div style="background-image: url(' + require('@/assets/' + image) + ')" class="logo"></div></br><span>' + replace.replaceAll('_', ' ') + '</span></div>';
      var replaced = text.replaceAll(replace.replaceAll('_', ' '), html);

      return replaced;
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    replaceMultiple(str, replacementsMap) {
      const sortedMap = this.sortMapByKeyStringLength(replacementsMap);
      const pattern = new RegExp(
        [...sortedMap.keys()].map(k => this.escapeRegExp(k.toString())).join('|'),
        'g'
      );

      return str.replace(pattern, match => {
        for (const [key, value] of sortedMap) {
          if (key.toString() === match) return value;
        }
        return match;
      });
    },
    sortMapByKeyStringLength(replacementsMap) {
      return new Map(
        [...replacementsMap.entries()]
          .sort((a, b) => b[0].toString().length - a[0].toString().length)
      );
    },
    addImgs(text) {

      const replacements = new Map();
      replacements.set(" ", " ");

      /* Icons */
      var files = require.context('@/assets/icons', false, /.$/)
      if (files === undefined) {
        return;
      }

      files.keys().forEach(file => {
        var filename = file.replace('./', '').split('.')[0]
        var image = file.replace('./', '')
        var replaceStr = filename.replaceAll('_', ' ');
        if (text.includes(replaceStr)) {
          var replacement = '<div style="display: inline-block;text-align: center;" ><div style="background-image: url(' + require('@/assets/icons/' + image) + ')" class="textImg"></div></br><span>' + filename.replaceAll('_', ' ') + '</span></div>';
          replacements.set(replaceStr, replacement);
        }
      });

      /* Items */
      files = require.context('@/assets/items', false, /.$/)
      if (files === undefined) {
        return;
      }

      files.keys().forEach(file => {
        var filename = file.replace('./', '').split('.')[0]
        var image = file.replace('./', '')
        var replaceStr = filename.replaceAll('_', ' ');
        if (text.includes(replaceStr)) {
          var replacement = '<div style="display: inline-block;text-align: center;" ><div style="background-image: url(' + require('@/assets/items/' + image) + ')" class="textImg"></div></br><span>' + filename.replaceAll('_', ' ') + '</span></div>';
          replacements.set(replaceStr, replacement);
        }
      });

      /* Logo */
      files = require.context('@/assets/logo', false, /.$/)
      if (files === undefined) {
        return;
      }

      files.keys().forEach(file => {
        var filename = file.replace('./', '').split('.')[0]
        var image = file.replace('./', '')
        var replaceStr = filename.replaceAll('_', ' ');
        if (text.includes(replaceStr)) {
          var replacement = '<div style="display: inline-block;text-align: center;" ><div style="background-image: url(' + require('@/assets/logo/' + image) + ')" class="logo"></div></br><span>' + filename.replaceAll('_', ' ') + '</span></div>';
          replacements.set(replaceStr, replacement);
        }
      });

      /* Person */
      files = require.context('@/assets/person', false, /.$/)
      if (files === undefined) {
        return;
      }

      files.keys().forEach(file => {
        var filename = file.replace('./', '').split('.')[0]
        var image = file.replace('./', '')
        var replaceStr = filename.replaceAll('_', ' ');
        if (text.includes(replaceStr)) {
          var replacement = '<div style="display: inline-block;text-align: center;" ><div style="background-image: url(' + require('@/assets/person/' + image) + ')" class="textImg"></div></br><span>' + filename.replaceAll('_', ' ') + '</span></div>';
          replacements.set(replaceStr, replacement);
        }
      });

      const sorted = this.sortMapByKeyStringLength(replacements);
      /* console.log(sorted); */

      return this.replaceMultiple(text, sorted);
    },
    addTeamColor(text) {
      text = text.replace('(Team #1)', '<span class="green-text">(Team #1)</span>');
      text = text.replace('(Team #2)', '<span class="blue-text">(Team #2)</span>');
      text = text.replace('(Team #3)', '<span class="orange-text">(Team #3)</span>');
      return text;
    },
    addFoundColor(text) {
      text = text.replace('(not found)', '<span class="red-text">(not found)</span>');
      text = text.replace('(found)', '<span class="green-text">(found)</span>');
      return text;
    },
    toHTMLRichText(text) {

      if (text === "") {
        return "";
      }

      var richText = text
      richText = this.addTeamColor(richText);
      richText = this.addFoundColor(richText);

      richText = this.addImgs(richText);

      return richText;
    },
    connect() {
      var self = this;
      const connectionInfo = {
        hostname: this.host,
        port: parseInt(this.port),
        game: this.game,
        name: this.name,
        password: this.password,
        items_handling: ITEMS_HANDLING_FLAGS.REMOTE_ALL,
      };

      //if connected
      window.client.disconnect();

      // Set up event listeners
      window.client.addListener(SERVER_PACKET_TYPE.CONNECTED, (packet) => {
        console.log("Connected to server: ", packet);
      });

      window.client.addListener(SERVER_PACKET_TYPE.ROOM_UPDATE, (packet) => {
        console.log("Room update: ", packet);
      });

      window.client.addListener(SERVER_PACKET_TYPE.RECEIVED_ITEMS, (packet) => {
        console.log("Recieved Items: ", packet);

        //length > 1 - First Connect > Overwrite Items
        if (packet.items.length > 1) {
          self.recievedItems = packet.items;
        } else {
          self.recievedItems = self.recievedItems.concat(packet.items);
        }

        self.forceUpdateComputed();
      });

      window.client.addListener(SERVER_PACKET_TYPE.LOCATION_INFO, (packet) => {
        console.log("Hint: ", packet);
        self.hints.concat(packet.items);
        self.forceUpdateComputed();
      });

      window.client.addListener(SERVER_PACKET_TYPE.PRINT_JSON, (packet) => {
        console.log("Print JSON: ", packet);
        self.log.push(packet);

        var msg = self.packetToText(packet.data);
        if (msg === "") {
          return;
        }

        console.log("MSG: " + msg);

        f7.toast.create({
          text: self.toHTMLRichText(msg),
          position: 'top',
          closeTimeout: 5000,
        }).open();

        if (packet.type === "ItemSend") {
          //PlaySound
          if (packet.receiving === self.getPlayerId(window.client.data.players, self.name)) {
            console.log("I got an item!" + packet.item.item);
            var audio = new Audio(require('@/assets/sounds/steam_achievement.mp3'));
            audio.play();
          }
        }
      });

      // Connect to the Archipelago server
      window.client
        .connect(connectionInfo)
        .then(() => {
          console.log("Connected to the server");

          var self = this;
          this.connectButtonClass = 'green';
          this.connectButtonText = 'Connected';

          self.saveSettings();
          self.forceUpdateComputed();
        })
        .catch((error) => {
          console.error("Failed to connect:", error);
          // Handle the connection error.
        });

      // Disconnect from the server when unloading window.
      window.addEventListener("beforeunload", () => {
        window.client.disconnect();
      });
    },
  },
  watch: {
    columnCount: 'columnCountChanged',
    search: 'forceUpdateComputed',
  },
  created() {
    window.client = new Client();

    console.log(window.Client);

    this.loadSettings();

    if (this.game !== '' && this.host !== '' && this.port !== '' && this.name !== '') {
      this.connect();
    }
  }



};
</script>

<style scoped>
/* Add your styles here */

.page {
  background-image: url('~@/assets/bg/0.png');
  background-size: cover;
  /* Optional: Adjust as needed */
  background-position: center;
  /* Optional: Adjust as needed */
}
</style>